<template>

  <div class="container pt-4 mb-4">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wpisz nazwę kursu:
              </label>

              <b-input-group>

                <b-form-input v-model="courseName" size="lg" ref="courseName" rows=10 placeholder="np. joga dla opornych"></b-form-input>

              </b-input-group>

            </div>


            
            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wpisz obietnicę kursu:
              </label>

              <b-input-group>

                <b-form-input v-model="promise" size="lg" ref="promise" rows=10 placeholder="np. z nami schudniesz"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wpisz markę lub autora kursu:
              </label>

              <b-input-group>

                <b-form-input v-model="author" size="lg" ref="author" rows=10 placeholder="np. Jan Kowalski"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Opisz do kogo kierowany jest kurs:
              </label>

              <b-input-group>

                <b-form-input v-model="targetAudience" size="lg" ref="targetAudience" rows=10 placeholder="np. osoby z nadwagą"></b-form-input>

              </b-input-group>

            </div>


            <div class="mt-3">
 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Tematyka kursu:
              </label>

              <b-input-group>

                <b-form-input v-model="courseTopic" size="lg" ref="courseTopic" rows=10 placeholder="np. joga, odchudzanie"></b-form-input>

              </b-input-group>

            </div>
 
          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Generuj okładkę kursu
          </b-button>

        </b-col>

      </b-row>

 
      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje grafikę <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Proszę czekać...</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" style="font-size: 1em;">

            <img ref="outputImg" style="width:100%;height:auto;" src="" />

          </blockquote>

        </b-card>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'AppGraphicAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      generatedImg: false,
      imageBase64: null,
      selectedText: '',
      query: "",
      courseName: "",
      promise: "",
      author: "",
      targetAudience: "",
      courseTopic: "",
      finishContent: '',
      selectedSchema: null
    }
  },
  methods: {
 
    generateFinish: function() {

      if(!this.courseName) return false;
      if(!this.promise) return false;
      if(!this.author) return false;
      if(!this.targetAudience) return false;
      if(!this.courseTopic) return false;

      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""

      var prompt =  
      
      "Create a premium 3D Course Bundle cover and mockup designed for digital products. \n" + 
      "Course name: "+this.courseName+" \n" + 
      "Subtitle / Promise: "+this.promise+" \n" + 
      "Instructor / Brand: "+this.author+" \n" + 
      "Target audience: "+this.targetAudience+" \n" + 
      "Industry / Topic: "+this.courseTopic+" \n" + 
 
      "Style: \n" + 
      "– ultra-realistic 3D render \n" + 
      "– clean, modern, premium digital product aesthetic \n" + 
      "– high contrast lighting \n" + 
      "– elegant, high-value color palette \n" + 
      "– NOT flat design, strong depth and realism \n" + 
 
      "Bundle Elements: \n" + 
      "– 3D box / course box \n" + 
      "– book-style covers \n" + 
      "– tablet mockup with course dashboard \n" + 
      "– smartphone mockup showing lesson preview \n" + 
      "– optional laptop mockup \n" + 
      "– elements arranged as a cohesive bundle \n" + 
 
      "3D Details: \n" + 
      "– realistic thickness and depth \n" + 
      "– subtle textures (matte, soft-touch, glossy accents) \n" + 
      "– realistic reflections and shadows \n" + 
      "– soft rim light for separation \n" + 
      "– slight perspective angle for depth \n" + 
 
      "Composition: \n" + 
      "– strong central focus \n" + 
      "– clear hierarchy. Course name dominant \n" + 
      "– subtitle secondary \n" + 
      "– minimal but powerful layout \n" + 
      "– clean background, subtle gradient or studio backdrop \n" + 
 
      "Typography: \n" + 
      "– bold, modern, readable fonts \n" + 
      "– large title \n" + 
      "– short promise-based subtitle \n" + 
      "– high contrast text \n" + 
      "– professional online education branding \n" + 
 
      "Mood: \n" + 
      "– authority \n" + 
      "– transformation \n" + 
      "– confidence \n" + 
      "– premium digital knowledge product \n" + 
 
      "Technical: \n" + 
      "– ultra high resolution \n" + 
      "– photorealistic mockup quality \n" + 
      "– suitable for sales pages, ads, landing pages, social media \n" + 
      "– looks premium even at small sizes \n" + 
 
      "Avoid: \n" + 
      "– clutter \n" + 
      "– cheap stock visuals \n" + 
      "– cartoon style \n" + 
      "– flat illustrations \n" + 
      "– amateur typography";

       

      this.axios.post(window.API_URL + "apps/graphicAi/paintnb/", { 'prompt': prompt }, { withCredentials: true, timeout: 60000 }).then((response2) => {

          let data = response2.data

          this.finishContent = true;

          this.$refs.outputImg.src = "data:image/jpeg;charset=utf-8;base64," + data.base64;

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana grafika"


        }).catch(function() {

          this.$refs.generatePost.disabled = false

        });



    }

  },
  computed: {

  },
  created() {

    this.$watch('finishContent', (value) => {

      var lines = value.split(/\r|\r\n|\n/);

      this.finishLinesCount = lines.length;

    })

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>